export enum PaymentSystemNetwork {
  TRC20,
  ERC20,
}
